import React, { useEffect, useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import styles from './ContactComponent.module.scss';
import metadata from './ContactComponent.metadata.json5';
// import AddressLookupComponent from '../AddressLookup/AddressLookupComponent';
import messages from 'gw-platform-translations/platform.messages';
import AddressComponent from "../Address/AddressComponent";


function ContactComponent(props) {
    const {contactVM, onValueChange} = props;

    const writeValue = (value, path) => {
        onValueChange(value, path);
    }

    const onAddressChange = (value, path) => {
        writeValue(value, `primaryAddress.${path}`);
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        companyContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Company'
        },
        personalContainer: {
            visible: _.get(contactVM, 'subtype.value') === 'Person' 
        },
        additionalInsuredCountry: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.country.aspects.availableValues'
                )
            )
        },
        additionalInsuredState: {
            visible: !_.isEmpty(
                _.get(
                    contactVM,
                    'primaryAddress.state.aspects.availableValues'
                )
            )
        },        
        contactAddressComponent:{
            model: contactVM.primaryAddress,
            onValueChange: onAddressChange
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
        },
        resolveComponentMap: {
            /*addressLookupComponent: AddressLookupComponent,*/
            addressComponent: AddressComponent
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={contactVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

export default ContactComponent;
